import { useEffect, useState } from "react";
import { useRouter } from "next/router";
import { useSelector } from "react-redux";
import { ask } from "../market/ui";
import { editionOf, extensionOn } from "../../lib/extensions/registry";

const LAST = "truechops.band.last";
const remembered = () => { try { return localStorage.getItem(LAST); } catch { return null; } };

// Which program the menu is about, and the visitor's role in it: the one that's open, otherwise the one
// they last had open, otherwise their first. { program: its slug, roles: [their role] }. On the full site
// the menu doesn't need to know, so only something that does asks (`always`).
export function useBandMenu({ always = false } = {}) {
  const router = useRouter(), user = useSelector((state) => state.realm.currentUser), [mine, setMine] = useState([]);
  const open = router.pathname.startsWith("/band/[slug]") ? router.query.slug : null, wanted = extensionOn("marching") && (always || editionOf() === "marching");
  useEffect(() => {
    if (!wanted || !user) { setMine([]); return undefined; }
    let alive = true;
    ask("marching/me").then((data) => { if (alive) setMine(Array.isArray(data?.programs) ? data.programs : []); }).catch(() => { if (alive) setMine([]); });
    return () => { alive = false; };
  }, [user?.id, open, wanted]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => { if (open) { try { localStorage.setItem(LAST, open); } catch { /* This visit only. */ } } }, [open]);
  const program = mine.find((item) => item.slug === open) || mine.find((item) => item.slug === remembered()) || mine[0] || null;
  return { program: program?.slug || null, roles: program ? [program.role] : [] };
}
